import gql from "graphql-tag";

export const CHARACTERISTIC_CATEGORIES_QUERY = gql`
  query CharacteristicCategories {
    characteristicCategories {
      id
      name
    }
  }
`;
